import { Action, createReducer, on } from '@ngrx/store';
import { initialPaymentFormsState } from './payment-forms.state';
import {
  initializePaymentFormsState,
  setAwardTransactionMPNumber,
  setBillingAddressForm,
  setBillingPhoneForm,
  setConfirmationEmailForm,
  setCurrentCreditRefundType,
  setCurrentPaymentType,
  setCyberSourceError,
  setCyberSourceTransientToken,
  setDontSendConfirmationEmail,
  setPaymentInformationForm,
  setRefundAtmosNumberForm,
  setRefundConfirmationEmailForm,
  setTaxIdInformation,
  setTaxIdRequired,
} from './payment-forms.actions';

const featureReducer = createReducer(
  initialPaymentFormsState,
  /**
   * Initialize the payment forms state
   */
  on(initializePaymentFormsState, (state) => ({ ...state, ...initialPaymentFormsState })),

  /**
   * Set the confirmation email form data
   */
  on(setConfirmationEmailForm, (state, { email }) => {
    // If email is set (not null), also ensure skipConfirmationEmail is false
    if (email !== '' && email != null) {
      return { ...state, confirmationEmail: email, skipConfirmationEmail: false };
    }
    return { ...state, confirmationEmail: email };
  }),

  /**
   * Set the refund confirmation email form data
   */
  on(setRefundConfirmationEmailForm, (state, { email }) => {
    return { ...state, refundConfirmationEmail: email };
  }),

  /**
   * Set the refund atmos number form data
   */
  on(setRefundAtmosNumberForm, (state, { atmosNumber }) => {
    return { ...state, refundAtmosNumber: atmosNumber };
  }),

  /**
   * Set the flag to skip sending confirmation email
   */
  on(setDontSendConfirmationEmail, (state, { skipConfirmationEmail }) => ({ ...state, skipConfirmationEmail })),

  /**
   * Set the billing address form data
   */
  on(setBillingAddressForm, (state, { billingAddress }) => ({ ...state, billingAddress })),

  /**
   * Set the billing phone form data
   */
  on(setBillingPhoneForm, (state, { billingPhone }) => ({ ...state, billingPhone })),

  /**
   * Set the payment information form data.
   */
  on(setPaymentInformationForm, (state, { paymentInformation }) => ({
    ...state,
    paymentInformation,
    cyberSourceTransientToken: paymentInformation?.cyberSourcePayment?.transientToken ?? null,
  })),

  /**
   * Set the CyberSource transient token
   */
  on(setCyberSourceTransientToken, (state, { cyberSourceTransientToken }) => ({ ...state, cyberSourceTransientToken })),

  /**
   * Set the CyberSource error flag
   */
  on(setCyberSourceError, (state, { cyberSourceError }) => {
    if (cyberSourceError) {
      // On error, also clear the transient token
      return { ...state, cyberSourceError, cyberSourceTransientToken: null };
    }
    return { ...state, cyberSourceError };
  }),

  /**
   * Set the current payment type
   */
  on(setCurrentPaymentType, (state, { paymentType }) => ({ ...state, currentPaymentType: paymentType })),
  on(setCurrentCreditRefundType, (state, { creditRefundType }) => ({ ...state, currentCreditRefundType: creditRefundType })),
  on(setAwardTransactionMPNumber, (state, { mpNumber }) => ({ ...state, awardTransactionMPNumber: mpNumber })),
  on(setTaxIdInformation, (state, { taxIdInformation }) => ({ ...state, taxIdInformation })),
  on(setTaxIdRequired, (state, { taxIdRequired }) => ({ ...state, taxIdRequired }))
);

export function paymentFormsReducer(state = initialPaymentFormsState, action: Action) {
  return featureReducer(state, action);
}
